export const getMobileOS = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Detectar iOS
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios';
  }

  // Detectar Android
  if (/android/i.test(userAgent)) {
    return 'android';
  }

  return 'other';
};

export const redirectToAppStore = () => {
  const os = getMobileOS();
  const iosUrl = 'https://apps.apple.com/app/id568894377';
  const androidUrl =
    'https://play.google.com/store/apps/details?id=com.dla.android';

  switch (os) {
    case 'ios':
      window.location.href = iosUrl;
      break;
    case 'android':
      window.location.href = androidUrl;
      break;
    default:
      window.location.href = androidUrl;
      break;
  }
};
